export const CoveoDPOSearchResultsStyles = (isMobile) => `
atomic-result-list::part(result-list) {
  grid-template-columns: repeat(2, 1fr);
  gap: 30px 30px;
  margin-bottom: 24px;
}

atomic-result-list::part(result-list-grid-clickable-container outline) {
  background: white;
  padding: 0;
  border-radius: 0;
}

a:hover .tile-title {
  text-decoration: underline;
}

.funding-provider {
  background-color: #fff;
  padding: 24px 24px 20px;
  height: 100%;
  text-decoration: none;
  display: block;
}

.funding-provider .funding-provider-labels {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
}

.funding-provider-type {
  font-size: 0.875rem;
  letter-spacing: .88px;
  line-height: 22px;
  font-weight: 500;
  text-transform: uppercase;
  color: #6e6259;
  font-family: var(--lbs-base-font-family), sans-serif;
}

.tile-title {
  font-family: var(--lbs-heading-font-family), serif;
  font-size: 1.875rem;
  line-height: 38px;
  margin-bottom: 15px;
}

.value-label {
  margin-bottom: 24px;
  line-height: 1.5;
  font-size: 1rem;
  color: #001e62;
  font-family:var(--lbs-base-font-family), sans-serif;
  font-weight: bold;
}

.open-to-label {
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 1.5;
  font-size: 1rem;
  font-family: var(--lbs-base-font-family), sans-serif;
}

.value-label dd,
.value-label dt,
.open-to-label dd,
.open-to-label dt {
  display: inline;
}

atomic-result-list::part(result-list) {
  grid-template-columns: ${isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"} ;
}

.coveo-status {
  border-bottom: 1px solid #001e62;
  padding-bottom: 19px;
  margin-bottom: 25px;
  min-height: 64px;
}
`;
